import {put, takeLatest, call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_VENUE_LOYALTY,
    GET_VENUE_LOYALTY_SUCCESS,
    GET_VENUE_LOYALTY_ERROR,
}
    from "../../actions/venue"

function* getVenueLoyaltySaga(action) {
    try {
       const data  = yield call(venueService.GetVenueLoyalty,action.payload)
        
       yield put({
        type: GET_VENUE_LOYALTY_SUCCESS,
        payload: data.loyalty
    })


    } catch (error) {
        yield put({
            type: GET_VENUE_LOYALTY_ERROR,error: error.data
        })
    }
}


export function* getVenueLoyaltySagaWatcher() {
    yield takeLatest(GET_VENUE_LOYALTY, getVenueLoyaltySaga)
}